import React, { Fragment } from "react";
import Sticky from "react-stickynode";
import { ThemeProvider } from "styled-components";
import { Modal } from "@redq/reuse-modal";
import { agencyTheme } from "common/src/theme/agency";
import { ResetCSS } from "common/src/assets/css/style";
import { GlobalStyle, AgencyWrapper } from "../containers/Agency/agency.style";
import Navbar from "../containers/Agency/Navbar";
import BannerSection from "../containers/Agency/BannerSection";
// import FeatureSection from '../containers/Agency/FeatureSection';
// import AboutUsSection from '../containers/Agency/AboutUsSection';
// import WorkHistory from '../containers/Agency/WorkHistory';
// import BlogSection from '../containers/Agency/BlogSection';
// import TestimonialSection from '../containers/Agency/TestimonialSection';
// import TeamSection from '../containers/Agency/TeamSection';
// import VideoSection from '../containers/Agency/VideoSection';
// import FaqSection from '../containers/Agency/FaqSection';
// import NewsletterSection from '../containers/Agency/NewsletterSection';
// import QualitySection from '../containers/Agency/QualitySection';
// import Footer from '../containers/Agency/Footer';
import { DrawerProvider } from "common/src/contexts/DrawerContext";
import "@redq/reuse-modal/es/index.css";
import SEO from "../components/seo";
// import govIcon from "../images/home/govIcon.png";
// import govIconK from "../images/home/govIconK.png";
import govIcon from "../images/home/Logo english - yuva.png";
import govIconK from "../images/home/Logo kannada - yuva.png";
import FeatureSection2 from "../containers/Hosting/Features";
import BranchSection from "../containers/Charity/BranchSection";
import VideoSection from "../containers/Agency/VideoSection";

import "../customElements/css/home.css";
import "../customElements/css/kannada.css";
import { Container } from "../customElements/components/yuvaContainer";
import Slider from "react-slick";
import "slick-carousel/slick/slick-theme.css";
import "../customElements/css/slick.css";

import slide1 from "../images/home/slide1.png";
import slide2 from "../images/home/slide2.png";
import slide3 from "../images/home/slide3.png";
import slide4 from "../images/home/slide4.png";
// import slide5 from "../images/home/slide5.png";
import leader1 from "../images/home/leader1.png";
import leader2 from "../images/home/leader2.png";
// import slide2 from "../images/home/slide1.png";
// import slide3 from "../images/home/slide1.png";

// import Container from "common/src/components/UI/Container";

import Layout from "../customElements/components/layout";
import councEng from "../images/Counselors-List-English.pdf";
import councKan from "../images/Counselors-List-Kannada.pdf";

import CustomSection from "../customElements/components/section";
import { render } from "react-dom";

export default class Home extends React.Component {
  constructor() {
    super();

    this.state = {
      isKannada: true
    };
    this.toggleLang = this.toggleLang.bind(this);
  }

  toggleLang() {
    this.setState({ isKannada: !this.state.isKannada });
  }
  render() {
    var btnWrapperStyle = {
      position: "absolute",
      bottom: "62px",
      left: "15%"
    };
    // next / prev btn style
    var btnStyle = {
      minWidth: "auto",
      minHeight: "auto",
      mr: "13px",
      fontSize: "44px",
      color: "#343d484d"
    };
    const settings = {
      className: "animate fadeIn one",
      dots: false,
      infinite: true,
      speed: 500,
      arrows: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      focusOnSelect: true,
      dotsClass: "slick-dots slick-thumb customDotsClass",
      autoplay: true,
      speed: 1000,
      autoplaySpeed: 6000,
      // beforeChange: (current, next) => {
      //   console.log("next and salect", next, salect);
      //   if (salect === 0) {
      //     return handlePyClick(next);
      //   } else {
      //     next += firstTabProjects;

      //     if (next >= secondTabProjects + firstTabProjects)
      //       return handlePyClick(next - secondTabProjects);
      //     else return handlePyClick(next);
      //   }
      // },

      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            initialSlide: 2
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            // arrows: false,
            dots: false
            // nextArrow: false,
            // prevArrow: false
          }
        }
      ]
      // nextArrow: <SampleNextArrow />,
      // prevArrow: <SamplePrevArrow />
    };

    return (
      <Layout
        title="Yuva | Home"
        toggleLang={this.toggleLang}
        isKannada={this.state.isKannada}
      >
        <div className="Banner">
          <div className="row align-items-center">
            <div className="col-lg-6 ">
              <Container>
                <div className="BannerContentWrapper">
                  <div className="bannerHeading">
                    {this.state.isKannada
                      ? "ಯುವ ಶಿಕ್ಷಣ, ಕ್ಷೇಮಾಭಿವೃದ್ಧಿ ಮತ್ತು ಉದ್ಯೋಗಾರ್ಹತೆ"
                      : "Youth Education, Welfare & Employability"}
                  </div>
                  <div className="bannerContent d-lg-flex align-items-center">
                    <div className="bannerImageWrapper">
                      <img
                        src={this.state.isKannada ? govIconK : govIcon}
                        className="govBannerLogo w-100"
                        alt="karnataka gov Logo"
                      ></img>
                    </div>
                    <span>
                      {this.state.isKannada ? (
                        "ಉದ್ಯೋಗ ಪಥಗಳು ಮತ್ತು ಉನ್ನತ ಶಿಕ್ಷಣದ ಅವಕಾಶಗಳತ್ತ ಬೆಳಕು ಚೆಲ್ಲುವ ಮೂಲಕ ಯುವಜನತೆಯ ಭವಿಷ್ಯವನ್ನು ರೂಪಿಸುವ ನಿಟ್ಟಿನಲ್ಲಿ ಯೋಗದಾನ ನೀಡುವುದು."
                      ) : (
                        <span>
                          "YEC is a State Government initiative to empower youth
                          with access to information, opportunity & tools for"{" "}
                          <strong> holistic personal developments</strong>
                        </span>
                      )}
                    </span>
                  </div>
                </div>
              </Container>
            </div>
            <div className="col-lg-6 p-0">
              <Slider {...settings}>
                <div>
                  <img
                    src={slide1}
                    className="bannerSlideImage"
                    alt="sports"
                  ></img>
                </div>
                <div>
                  <img
                    src={slide2}
                    className="bannerSlideImage"
                    alt="sports"
                  ></img>
                </div>
                <div>
                  <img
                    src={slide3}
                    className="bannerSlideImage"
                    alt="sports"
                  ></img>
                </div>
                {/* <div>
                  <img
                    src={slide4}
                    className="bannerSlideImage"
                    alt="sports"
                  ></img>
                </div> */}
              </Slider>
            </div>
          </div>
        </div>
        <div className="section">
          <Container>
            <div className="infoCtaSection">
              <div className="infoCtaSectionInner">
                <div className="infoCtaSectionLeft">
                  <div className="infoCtaSectionHeading">
                    {this.state.isKannada
                      ? "ಹೆಚ್ಚಿನ ಸ್ಪಷ್ಟತೆ ಬೇಕೆ? ವಿವರಪೂರ್ಣ ಮಾಹಿತಿಗಾಗಿ ನೋಂದಾಯಿಸಿಕೊಳ್ಳಿ"
                      : "Need Details? Register to know more"}
                  </div>
                  {/* <div className="infoCtaSectionSubHeading">
                    Lorem ipsum dolor sit amet, conse ctetur adipiscing elit,
                    sed do eiusmod.
                  </div> */}
                </div>
                <div className="infoCtaSectionRight">
                  <a href="/register/" target="newtab">
                    <button className="infoCtaRedbutton ">
                      <span>
                        {/* {this.state.isKannada ? "" : "Register now"}  */}
                        {this.state.isKannada ? "ನೋಂದಾಯಿಸಿ" : "Register"}
                      </span>
                    </button>
                  </a>
                </div>
              </div>
            </div>
          </Container>
        </div>
        {/* <CustomSection
          secTitle="Leadership"
          secHeading=" Initiative led by Karnataka Government State Council"
          dim={true}
        >
          <div className="row">
            <div className="col-md-6">
              <div className="leadderBox d-sm-flex d-lg-flex align-items-center justify-content-around">
                <div className="leaderBoxImage">
                  <img
                    className="leaderBoxImage"
                    src={leader1}
                    alt="yediyrappa"
                  ></img>
                </div>
                <div className="leaderBoxContentWrapper">
                  <div className="leaderBoxContentHeading">
                    B. S. Yediyurappa
                  </div>
                  <div className="leaderBoxContentSubHeading">
                    Chief Minister of
                    <br />
                    Karnataka
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="leadderBox d-sm-flex d-lg-flex align-items-center justify-content-around">
                <div className="leaderBoxImage">
                  <img
                    className="leaderBoxImage"
                    src={leader2}
                    alt="yediyrappa"
                  ></img>
                </div>
                <div className="leaderBoxContentWrapper">
                  <div className="leaderBoxContentHeading">
                    C. N. Ashwathnarayan
                  </div>
                  <div className="leaderBoxContentSubHeading">
                    Deputy Chief Minister of
                    <br />
                    Karnataka
                  </div>
                </div>
              </div>
            </div>
          </div>
        </CustomSection> */}

        <CustomSection
          secTitle={
            this.state.isKannada
              ? "ಯುವಸಬಲೀಕರಣ ಕೇಂದ್ರ"
              : "Youth empowerment centre"
          }
          secHeading={
            this.state.isKannada ? "ಇತ್ತೀಚಿನ ಸುದ್ದಿ" : " Latest Information"
          }
          dim={false}
        >
          <FeatureSection2 isKannada={this.state.isKannada} />
          <Container>
            <div className="infoCtaSection">
              <div className="infoCtaSectionInner">
                <div className="infoCtaSectionLeft">
                  <div className="infoCtaSectionHeading">
                    {this.state.isKannada
                      ? "ನಿಮ್ಮ ಮನೋವೈಜ್ಞಾನಿಕ ಪರೀಕ್ಷೆಯನ್ನು ತೆಗೆದುಕೊಳ್ಳಿ"
                      : "Take Your Psychological Test"}
                  </div>
                  {/* <div className="infoCtaSectionSubHeading">
                    Lorem ipsum dolor sit amet, conse ctetur adipiscing elit,
                    sed do eiusmod.
                  </div> */}
                </div>
                <div className="infoCtaSectionRight">
                  <a href="/psychologicalassessment/" target="newtab">
                    <button className="infoCtaRedbutton ">
                      <span>
                        {this.state.isKannada
                          ? "ಪರೀಕ್ಷೆಯನ್ನು ಪ್ರಾರಂಭಿಸಿ"
                          : "Start Psychometric Test"}
                      </span>
                    </button>
                  </a>
                </div>
              </div>
            </div>
          </Container>
        </CustomSection>
        <BranchSection isKannada={this.state.isKannada} />
        <CustomSection
          secTitle={this.state.isKannada ? "ವಿವೇಕಾನಂದ ಜಯಂತಿಯ" : "MESSAGE ON"}
          secHeading={
            this.state.isKannada
              ? "ಶುಭ ಸಂದರ್ಭದಂದು ಸಂದೇಶ"
              : "Vivekananda Jayanthi"
          }
          dim={true}
        >
          <VideoSection />
        </CustomSection>

        <div className="section">
          <Container>
            <div className="infoCtaSection">
              <div className="infoCtaSectionInner">
                <div className="infoCtaSectionLeft">
                  <div className="infoCtaSectionHeading">
                    {this.state.isKannada
                      ? "ನಿಮ್ಮ ಸಲಹೆಗಾರರು ಮತ್ತು YEC ಕೇಂದ್ರಗಳನ್ನು ತಿಳಿದುಕೊಳ್ಳಿ"
                      : "Know your YEC & Counsellors"}
                  </div>
                  {/* <div className="infoCtaSectionSubHeading">
                    Lorem ipsum dolor sit amet, conse ctetur adipiscing elit,
                    sed do eiusmod.
                  </div> */}
                </div>
                <div className="infoCtaSectionRight">
                  <a
                    href={this.state.isKannada ? councKan : councEng}
                    target="newtab"
                  >
                    <button className="infoCtaRedbutton ">
                      <span>
                        {this.state.isKannada
                          ? "ವಿವರಗಳನ್ನು ವೀಕ್ಷಿಸಿ"
                          : "View Details"}
                      </span>
                    </button>
                  </a>
                </div>
              </div>
            </div>
          </Container>
        </div>
      </Layout>
    );
  }
}
